import type { Response } from "@/types/global"
import { HttpRequest } from "@/utils/request"
import type { PageQueryParams, CollectionResponse } from "@/types/global"

export interface AdminSearchParams extends PageQueryParams {
  query?: string
  is_active?: number
  role_id?: number
}

export interface AdminFormParams {
  id?: number
  full_name: string
  username: string
  password: string
  email: string
  role: string
  is_active?: number
}

export interface ChangePasswordParams {
  old_password: string
  new_password: string
}

export const adminService = {
  list(params: AdminSearchParams) {
    return HttpRequest.get("v1/admin/list", {
      searchParams: params,
    }).json<CollectionResponse>()
  },

  create(params: AdminFormParams) {
    return HttpRequest.post("v1/admin/create", {
      json: params,
    }).json<Response>()
  },

  update(params: AdminFormParams) {
    return HttpRequest.put("v1/admin/update", {
      json: params,
    }).json<Response>()
  },

  changePassword(params: ChangePasswordParams) {
    return HttpRequest.put("v1/admin/change-password", {
      json: params,
    }).json<Response>()
  },
}
